import { t, useLocale } from "../lib/i18n";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useApplyAppearance } from "../lib/appearance";
import { CommandPalette } from "./CommandPalette";
import { ActivityInbox } from "./ActivityInbox";
import { getConsoleConnections, requestConnectionSettings } from "../lib/api";

export function Layout() {
  const locale = useLocale();
  useEffect(() => { document.documentElement.lang = locale; }, [locale]);
  useApplyAppearance();
  const location = useLocation();
  const [connections, setConnections] = useState(getConsoleConnections);

  useEffect(() => {
    const refresh = () => setConnections(getConsoleConnections());
    window.addEventListener("swarm-connections-changed", refresh);
    return () => {
      window.removeEventListener("swarm-connections-changed", refresh);
    };
  }, []);

  const controlReady = !!connections.controlBase && !!connections.controlToken;
  const traceReady = connections.traceBase
    ? !!connections.traceToken
    : !!(connections.traceToken || connections.controlToken);

  return (
    <div className="console-shell">
      <header className="console-header">
        <NavLink to="/sessions" className="console-brand" aria-label={t("swarm-rs sessions")}>
          <span className="brand-mark" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
          <span>
            <strong>SWARM</strong>
            <small>{t("operator console")}</small>
          </span>
        </NavLink>

        <nav className="console-nav" aria-label={t("Primary navigation")}>
          <NavLink to="/sessions" className={({ isActive }) => (isActive ? "active" : "")}>
            {t("Sessions")}</NavLink>
          <NavLink to="/agents" className={({ isActive }) => (isActive ? "active" : "")}>{t("Agents")}</NavLink>
          <NavLink to="/traces" className={({ isActive }) => (isActive ? "active" : "")}>
            {t("Traces")}</NavLink>
          <NavLink to="/jobs" className={({ isActive }) => (isActive ? "active" : "")}>
            {t("Jobs")}</NavLink>
        </nav>

        <div className="connection-status" aria-label={t("Configured connections")}>
          <span title={t("Agent control configuration")}>
            <i className={controlReady ? "is-configured" : ""} />
            {controlReady ? t("Control set") : t("Control unset")}
          </span>
          <span title={t("Trace archive configuration")}>
            <i className={traceReady ? "is-configured" : ""} />
            {traceReady ? t("Trace set") : t("Trace unset")}
          </span>
        </div>
        <CommandPalette />
        <ActivityInbox />
        <button id="console-connections" className="settings-button" aria-label={t("Connections")} type="button" onClick={requestConnectionSettings}>
          <SettingsIcon />
          <span>{t("Connections")}</span>
        </button>
      </header>

      <main
        className={`console-main ${
          location.pathname.startsWith("/sessions")
            ? "console-main--chat"
            : location.pathname.startsWith("/jobs")
              ? "console-main--jobs"
            : "console-main--trace"
        }`}
      >
        <Outlet />
      </main>

    </div>
  );
}

function SettingsIcon() {
  useLocale();
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
      <path d="M4 7h10M18 7h2M4 17h2M10 17h10M14 4v6M6 14v6" />
    </svg>
  );
}
